<template>
  <BaseImage
    v-for="headerNavigationItem in headerNavigationList"
    :key="headerNavigationItem.id"
    :id="headerNavigationItem.id"
    :src="headerNavigationItem.imgSrc"
    :alt="headerNavigationItem.imgAlt"
    @click="handleRedirection(headerNavigationItem.routeName)"
  />
</template>

<script setup>
import { computed } from 'vue';
import BaseImage from '@/components/image/BaseImage.vue';
import useAppSettingsStore from '@/store/modules/appSettings.js';
import useNotificationStore from '@/store/modules/notification.js';
import useMenuStore from '@/store/modules/menu.js';
import usePageNavigationHook from '@/hooks/usePageNavigation.js';

const props = defineProps({
  userAuthenticated: {
    type: Boolean,
  },
});

const appSettingsStore = useAppSettingsStore();
const notificationStore = useNotificationStore();
const menuStore = useMenuStore();

const { redirectTo } = usePageNavigationHook();

const headerNavigationList = computed(() => {
  if (!props.userAuthenticated) {
    return [];
  }

  const list = [];

  if (!appSettingsStore.isStoreDisabled) {
    list.push({
      id: 'store',
      imgSrc: '/static/images/header-menu/store.svg',
      imgAlt: 'Store',
      routeName: 'Store',
    });
  }

  list.push({
    id: 'notifications',
    imgSrc: notificationStore.hasUnreadNotifications ? '/static/images/header-menu/notifications_yes.svg' : '/static/images/header-menu/notifications_no.svg',
    imgAlt: 'Notifications',
    routeName: 'Notifications',
  });

  list.push({
    id: 'profile',
    imgSrc: '/static/images/header-menu/profile.svg',
    imgAlt: 'Profile',
    routeName: 'ProfileOverview',
  });

  return list;
});

const handleRedirection = routeName => {
  redirectTo(routeName);

  menuStore.closeMenu();
};
</script>
